module.exports = __webpack_public_path__ + "static/media/mutum-capa.9ae52967.png";